export const PublicationController = {
    index(): void {},
    show(): void {},
};
